$ = jQuery;

import { formGeneral } from './partials/forms/general';
import { formNewsletter } from './partials/forms/newsletter';
import { formAuth } from "./partials/forms/auth";

formGeneral();
formNewsletter();
formAuth();